import styled from 'styled-components';
import VizExStatusIndicator from 'visitor-ui-component-library/indicator/VizExStatusIndicator';
import ChatHead from 'conversations-visitor-experience-components/visitor-widget/ChatHead';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderContent = styled.div.withConfig({
  displayName: "SpotlightPopupHeader__HeaderContent"
})(["flex:1;min-width:0;display:flex;align-items:flex-start;gap:", ";"], ({
  theme
}) => theme.spotlight.spacing.sm);
const AvatarWrapper = styled.div.withConfig({
  displayName: "SpotlightPopupHeader__AvatarWrapper"
})(["flex-shrink:0;"]);
const Content = styled.div.withConfig({
  displayName: "SpotlightPopupHeader__Content"
})(["flex:1;min-width:0;"]);
const AgentName = styled.p.withConfig({
  displayName: "SpotlightPopupHeader__AgentName"
})(["margin:0 0 ", " 0;font-size:", ";font-weight:", ";color:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], ({
  theme
}) => theme.spotlight.spacing.xs, ({
  theme
}) => theme.spotlight.typography.fontSize.md, ({
  theme
}) => theme.spotlight.typography.fontWeight.regular, ({
  theme
}) => theme.spotlight.color.muted);
const SpotlightChatHead = styled(ChatHead).withConfig({
  displayName: "SpotlightPopupHeader__SpotlightChatHead"
})(["", "::after{bottom:0;}"], VizExStatusIndicator);
// Shared avatar + name row for popups that represent a specific
// agent/responder.
const SpotlightPopupHeader = ({
  avatarUrl,
  avatarName,
  isBot,
  isResponderAI,
  isOnline = false,
  showStatus = false,
  nameLine,
  children
}) => /*#__PURE__*/_jsxs(HeaderContent, {
  children: [/*#__PURE__*/_jsx(AvatarWrapper, {
    children: /*#__PURE__*/_jsx(SpotlightChatHead, {
      avatar: avatarUrl,
      avatarName: avatarName,
      isBot: isBot,
      isResponderAI: isResponderAI,
      online: isOnline,
      showStatus: showStatus,
      size: "sm"
    })
  }), /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsx(AgentName, {
      children: nameLine
    }), children]
  })]
});
SpotlightPopupHeader.displayName = 'SpotlightPopupHeader';
export default SpotlightPopupHeader;